// src/components/CountrySelector.js
import {
  Dialog, DialogTitle, DialogContent, DialogActions, Button,
  Select, MenuItem, Typography, Box
} from "@mui/material";
import countries from "../countries.json";
import { useTranslation } from "react-i18next";

const SUPPORTED_COUNTRIES = [2, 1];

const CountrySelector = ({ open, country, setCountry, onClose, lockOpen = false }) => {
  const { t } = useTranslation();

  return (
    <Dialog
      open={open}
      disableEscapeKeyDown={lockOpen}
      onClose={(e, reason) => {
        if (lockOpen && (reason === "backdropClick" || reason === "escapeKeyDown")) {
          onClose && onClose(reason);
          return;
        }
        onClose && onClose(reason);
      }}
    >
      <DialogTitle>{t('select_country') || "Επιλέξτε χώρα"}</DialogTitle>
      <DialogContent>
        <Box sx={{ mb: 2 }}>
          <Typography color="info.main" fontWeight={500} align="center">
            {t("available_countries_message") ||
              "Υποστηρίζονται Ελλάδα & ΗΠΑ. Για ΗΠΑ θα σας ζητήσουμε ZIP."}
          </Typography>
        </Box>
        <Select
          value={country}
          onChange={e => setCountry(e.target.value)}
          fullWidth
          sx={{ minWidth: 200 }}
        >
          {countries.map(c => (
            <MenuItem
              key={c.id}
              value={c.id}
              disabled={!SUPPORTED_COUNTRIES.includes(c.id)}
              sx={!SUPPORTED_COUNTRIES.includes(c.id) ? { opacity: 0.5 } : {}}
            >
              <span style={{ marginRight: 8 }}>{c.flag}</span>
              {c.name_el} / {c.name_en}
              {!SUPPORTED_COUNTRIES.includes(c.id) &&
                <Typography variant="caption" sx={{ ml: 1, color: "gray" }}>
                  {t("coming_soon") || "Σύντομα διαθέσιμο"}
                </Typography>
              }
            </MenuItem>
          ))}
        </Select>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() => {
            if (lockOpen && !country) return;
            onClose && onClose("ok");
          }}
          disabled={!country}
        >
          OK
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CountrySelector;
